"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../../constants");

var _tourDriverLinkDialog = _interopRequireDefault(require("./actions-dialog/tour-driver-link-dialog"));

var _tourLinkDialog = _interopRequireDefault(require("./actions-dialog/tour-link-dialog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ActionsCell = function ActionsCell(_ref) {
  var cellData = _ref.cellData,
      tour = _ref.rowData;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _usePermissions = (0, _nicbaseSecurity.usePermissions)('PORTAL'),
      hasPermissions = _usePermissions.hasPermissions;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      terminateTourActive = _useState2[0],
      setTerminateTourActive = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      startTourActive = _useState4[0],
      setStartTourActive = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      deleteTourActive = _useState6[0],
      setDeleteTourActive = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      tourDriverLinkActive = _useState8[0],
      setTourDriverLinkActive = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      tourLinkActive = _useState10[0],
      setTourLinkActive = _useState10[1];

  var tourStatus = cellData.tourStatus,
      onTerminateClick = cellData.onTerminateClick,
      onStartClick = cellData.onStartClick,
      onDeleteClick = cellData.onDeleteClick,
      onAssetRequestClick = cellData.onAssetRequestClick,
      onDetailsClick = cellData.onDetailsClick,
      onEditClick = cellData.onEditClick,
      useAsTemplate = cellData.useAsTemplate,
      onReportExportClicked = cellData.onReportExportClicked,
      onExportTransportOrderClick = cellData.onExportTransportOrderClick;
  var _tour$sharedWithPorta = tour.sharedWithPortals,
      sharedWithPortals = _tour$sharedWithPorta === void 0 ? [] : _tour$sharedWithPorta,
      _tour$owningPortal = tour.owningPortal,
      owningPortal = _tour$owningPortal === void 0 ? {} : _tour$owningPortal,
      status = tour.status,
      assetId = tour.assetId,
      dataRequest = tour.dataRequest;

  var confirmTerminate = function confirmTerminate(isConfirmed) {
    if (isConfirmed === true) {
      onTerminateClick();
    }

    setTerminateTourActive(false);
  };

  var confirmStart = function confirmStart(isConfirmed) {
    if (isConfirmed === true) {
      onStartClick();
    }

    setStartTourActive(false);
  };

  var confirmDelete = function confirmDelete(isConfirmed) {
    if (isConfirmed === true) {
      onDeleteClick();
    }

    setDeleteTourActive(false);
  };

  var isDataRequested = (dataRequest === null || dataRequest === void 0 ? void 0 : dataRequest.haulerPortalId) === portalId;
  var isReceivedTabActivated = tourStatus.received === true || isDataRequested;
  var canDisplayDetails = true;
  var isTourboardExtended = hasPermissions(['module.tour.extended']); // NICBASE-44932 Frontend: Wenn Tour haulerPortalId UND asset hat darf die Tour nicht mehr bearbeitbar sein

  var isTourUneditable = (dataRequest === null || dataRequest === void 0 ? void 0 : dataRequest.haulerPortalId) && tour.assetId;
  var isAllowedToUpdate = isTourboardExtended && [owningPortal].concat(_toConsumableArray(sharedWithPortals)).some(function (portal) {
    return portal.id === portalId && portal.write;
  });
  var isAllowedToTerminate = isAllowedToUpdate && status === _constants.TOUR_STATUS.RUNNING;
  var isAllowedToStart = hasPermissions(['module.tour.start']) && status === _constants.TOUR_STATUS.WAITING && assetId !== null && assetId !== undefined;
  var isAllowedToEdit = !isTourUneditable && isAllowedToUpdate && status === _constants.TOUR_STATUS.WAITING;
  var isAllowedToExport = isTourboardExtended && status === _constants.TOUR_STATUS.FINISHED;
  var isAllowedToCopyTour = isTourboardExtended && owningPortal.id === portalId;
  var isAllowedToLinkTour = isTourboardExtended && tour.token;
  var isAllowedToSendTourDriverLink = isTourboardExtended && tour.token && status === _constants.TOUR_STATUS.WAITING && owningPortal.id === portalId && (dataRequest === null || dataRequest === void 0 ? void 0 : dataRequest.type) === 'APP';
  var isAllowedToExportTransportOrder = hasPermissions(['module.greenyard.export']);
  var displayFlyout = !isReceivedTabActivated && (canDisplayDetails || isAllowedToUpdate || isAllowedToCopyTour || isAllowedToTerminate || isAllowedToStart || isAllowedToEdit || isAllowedToExport || isAllowedToLinkTour || isAllowedToSendTourDriverLink || isAllowedToExportTransportOrder);
  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick(event) {
      return event.stopPropagation();
    }
  }, isReceivedTabActivated && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOut, {
    hideOnItemClick: true
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: onAssetRequestClick
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.onAssetRequestClick"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: onDetailsClick
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.details"
  }))), displayFlyout && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOut, {
    hideOnItemClick: true
  }, canDisplayDetails && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: onDetailsClick
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.details"
  })), isAllowedToEdit && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: onEditClick
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.edit"
  })), isAllowedToTerminate && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: function onClick() {
      return setTerminateTourActive(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.terminate"
  })), isAllowedToStart && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: function onClick() {
      return setStartTourActive(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.start"
  })), isAllowedToEdit && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: function onClick() {
      return setDeleteTourActive(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.delete"
  })), isAllowedToCopyTour && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: useAsTemplate
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.useAsTemplate"
  })), isAllowedToExport && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: onReportExportClicked
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.requestTourReport"
  })), isAllowedToLinkTour && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: function onClick() {
      return setTourLinkActive(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourLink"
  })), isAllowedToSendTourDriverLink && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: function onClick() {
      return setTourDriverLinkActive(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.tourDriverLink"
  })), isAllowedToExportTransportOrder && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiFlyOutItem, {
    onClick: onExportTransportOrderClick
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.actions.exportTourOrder"
  }))), terminateTourActive && /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.ConfirmDialog, {
    active: terminateTourActive,
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.terminate.title"
    }),
    content: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.terminate.text"
    }),
    confirmText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.terminate.confirm"
    }),
    cancelText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.terminate.cancel"
    }),
    onCloseDialog: confirmTerminate
  }), startTourActive && /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.ConfirmDialog, {
    active: startTourActive,
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.start.title"
    }),
    content: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.start.text"
    }),
    confirmText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.start.confirm"
    }),
    cancelText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.start.cancel"
    }),
    onCloseDialog: confirmStart
  }), deleteTourActive && /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.ConfirmDialog, {
    active: deleteTourActive,
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.delete.title"
    }),
    content: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.delete.text"
    }),
    confirmText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.delete.confirm"
    }),
    cancelText: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.delete.cancel"
    }),
    onCloseDialog: confirmDelete
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog, {
    active: tourDriverLinkActive
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Header, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.actions.tourDriverLink.title"
    })
  }), /*#__PURE__*/_react["default"].createElement(_tourDriverLinkDialog["default"], {
    tour: tour,
    closeDialog: function closeDialog() {
      return setTourDriverLinkActive(false);
    }
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog, {
    active: tourLinkActive
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.Dialog.Header, {
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.tourLink"
    })
  }), /*#__PURE__*/_react["default"].createElement(_tourLinkDialog["default"], {
    onCancel: function onCancel() {
      return setTourLinkActive(false);
    },
    tour: tour
  })));
};

ActionsCell.propTypes = {
  cellData: _propTypes["default"].shape({
    onAssetRequestClick: _propTypes["default"].func,
    onEditClick: _propTypes["default"].func,
    onTerminateClick: _propTypes["default"].func,
    onStartClick: _propTypes["default"].func,
    onDeleteClick: _propTypes["default"].func,
    onDetailsClick: _propTypes["default"].func,
    useAsTemplate: _propTypes["default"].func,
    onReportExportClicked: _propTypes["default"].func,
    onCreateLinkClick: _propTypes["default"].func,
    onExportTransportOrderClick: _propTypes["default"].func,
    tourStatus: _propTypes["default"].shape({
      received: _propTypes["default"].bool
    })
  }),
  rowData: _propTypes["default"].shape({
    sharedWithPortals: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number,
      write: _propTypes["default"].bool
    })),
    owningPortal: _propTypes["default"].shape({
      id: _propTypes["default"].number
    }),
    status: _propTypes["default"].string,
    assetId: _propTypes["default"].number,
    dataRequest: _propTypes["default"].shape({
      haulerPortalId: _propTypes["default"].number,
      type: _propTypes["default"].string
    }),
    token: _propTypes["default"].string
  })
};

var noop = function noop() {};

ActionsCell.defaultProps = {
  cellData: {
    onAssetRequestClick: noop,
    onEditClick: noop,
    onTerminateClick: noop,
    onStartClick: noop,
    onDeleteClick: noop,
    onDetailsClick: noop,
    useAsTemplate: noop,
    onReportExportClicked: noop,
    onCreateLinkClick: noop,
    onExportTransportOrderClick: noop,
    tourStatus: {
      received: false
    }
  },
  rowData: {}
};
var _default = ActionsCell;
exports["default"] = _default;